
import Vue from 'vue';
import Component from 'vue-class-component';
import RegistroPontoNovo from './RegistroPontoNovo/RegistroPontoNovo.vue';
import RegistroPontoUnidade from './RegistroPontoUnidade/RegistroPontoUnidade.vue';
import CommonRequests from '@/assets/ts/controller/CommonRequests';

@Component({
  components: {
    RegistroPontoNovo,
    RegistroPontoUnidade,
  },
})
export default class RegistroPontoRedirect extends Vue {
  version: string = null;

  created(): void {
    this.loadValorRegistroPontoVersion();
  }

  async loadValorRegistroPontoVersion(): Promise<void> {
    const valorReferencia = await CommonRequests.getValorReferencia('REGISTRO_PONTO_OLD');
    this.version = valorReferencia === '1' ? 'v1' : 'v2';
  }
}
